import { FC, useState, useEffect, useMemo } from 'react';
import { Paper, Modal, Grid, FormControl, IconButton } from '@material-ui/core';
import { useStyles } from './styles';
import { ClientActivatePopUpProps } from './types';
import CloseIcon from '@material-ui/icons/Close';
import { observer } from 'mobx-react-lite';
import LinearProgress from '@mui/material/LinearProgress';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useQuery } from 'react-query';
import { useStore } from 'hooks/useRootStore';
import { useMutation } from 'react-query';

export const ClientProgress: FC<ClientActivatePopUpProps> = observer(({ open, handleClose }) => {
  const {
    ClientProgressStore: { getTierType, tierType, postEndRequest },
    userStore: { getProfileInfo },
    notificationStore: { openNotification },
  } = useStore();
  const getUserProfileinfo = useQuery('getUserProfileInfo', () => getProfileInfo(), {
    onError: (e) => {
      openNotification('error', `Can't get profile info`);
    },
  });
  const firstName = getUserProfileinfo.data?.firstName || '';
  const getTier = useQuery('getTierType', () => getTierType());
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const limitValue = 14.28;
  const tierTypeData = useMemo(() => {
    return !getTier.isFetching ? tierType : tierType;
  }, [getTier.isFetching, tierType]);
  const getStartedProgress = () => {
    let progessValue = 0;
    if (tierTypeData?.endUser && tierTypeData?.group && tierTypeData?.department) {
      progessValue += limitValue;
    }
    if (tierTypeData?.inviteNewUserCreateAccount) {
      progessValue += limitValue;
    }
    if (tierTypeData?.inviteNewCurrentUserPasswordUpdate) {
      progessValue += limitValue;
    }
    if (tierTypeData?.createEndUserPortal) {
      progessValue += limitValue;
    }
    if (tierTypeData?.importCsvLdif) {
      progessValue += limitValue;
    }
    if (tierTypeData?.uploadUpdateEndUserAccount) {
      progessValue += limitValue;
    }
    if (tierType?.configurePortalWithLdapAuthentication) {
      progessValue += limitValue;
    }
    setValue(progessValue);
  };
  const PostRequest = useMutation((data: string) => postEndRequest(data), {
    mutationKey: 'postEndRequest',
    onSuccess: () => {
      getTier.refetch();
      getStartedProgress();
    },
    onError: () => console.log('error'),
  });
  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    PostRequest.mutate(value);
  };
  useEffect(() => {
    getStartedProgress();
  });
  return (
    <Modal className={classes.modal} disablePortal disableEnforceFocus disableAutoFocus open={open}>
      <Paper className={classes.paper} elevation={3}>
        <Grid className={classes.topBar} container justify='space-between' alignItems='center'>
          <div className={classes.title}>Getting Started</div>
          <IconButton
            style={{ marginRight: -16 }}
            onClick={() => {
              handleClose();
            }}>
            <CloseIcon />
          </IconButton>
        </Grid>
        <div className={classes.flexBox}>
          <form className={classes.formContainer}>
            <Grid container justify='space-between'>
              <Grid className={classes.block} container>
                <Grid className={classes.fullRow} container>
                  <FormControl className={classes.input}>
                    <h1 className={classes.title}> Hello {firstName}! </h1>
                    <span> You're gonna be a EasyIdentity superstar! </span>
                  </FormControl>
                </Grid>
              </Grid>
              <div className={classes.progressBar}>
                <LinearProgress variant='determinate' value={value} />
              </div>
              <div>
                <>
                  <FormControl className={classes.input}>
                    <>
                      {tierTypeData?.endUser && tierTypeData?.group && tierTypeData?.department ? (
                        <>
                          <FormControlLabel
                            control={
                              <>
                                <Checkbox checked />
                                <s>Add New End-Users, Groups, Departments</s>
                              </>
                            }
                            label=' '
                          />
                        </>
                      ) : (
                        <>
                          <FormControlLabel
                            control={<Checkbox onChange={handleChange} />}
                            value='endUser'
                            label='Add New End-Users, Groups, Departments'
                          />
                        </>
                      )}
                      {tierTypeData?.inviteNewUserCreateAccount ? (
                        <>
                          <FormControlLabel
                            control={
                              <>
                                <Checkbox checked />
                                <s>Invite a New End-User to Create Account</s>
                              </>
                            }
                            label=' '
                          />
                        </>
                      ) : (
                        <>
                          <FormControlLabel
                            control={<Checkbox onChange={handleChange} />}
                            value='inviteNewUserCreateAccount'
                            label='Invite a New End-User to Create Account'
                          />
                        </>
                      )}
                      {tierTypeData?.inviteNewCurrentUserPasswordUpdate ? (
                        <>
                          <FormControlLabel
                            control={
                              <>
                                <Checkbox checked />
                                <s>Invite a New/Existing End-User to Update Password</s>
                              </>
                            }
                            label=' '
                          />
                        </>
                      ) : (
                        <>
                          <FormControlLabel
                            control={<Checkbox onChange={handleChange} />}
                            value='inviteNewCurrentUserPasswordUpdate'
                            label='Invite a New/Existing End-User to Update Password'
                          />
                        </>
                      )}
                      {tierTypeData?.createEndUserPortal ? (
                        <>
                          <FormControlLabel
                            control={
                              <>
                                <Checkbox checked />
                                <s>Create/Configure End-User Portal</s>
                              </>
                            }
                            label=' '
                          />
                        </>
                      ) : (
                        <>
                          <FormControlLabel
                            control={<Checkbox onChange={handleChange} />}
                            value='createEndUserPortal'
                            label='Create/Configure End-User Portal'
                          />
                        </>
                      )}
                      {tierTypeData?.importCsvLdif ? (
                        <>
                          <FormControlLabel
                            control={
                              <>
                                <Checkbox checked />
                                <s>Import CSV/LDIF file to create/update End-User accounts</s>
                              </>
                            }
                            label=' '
                          />
                        </>
                      ) : (
                        <>
                          <FormControlLabel
                            control={<Checkbox onChange={handleChange} />}
                            value='importCsvLdif'
                            label='Import CSV/LDIF file to create/update End-User accounts'
                          />
                        </>
                      )}
                      {tierTypeData?.uploadUpdateEndUserAccount ? (
                        <>
                          <FormControlLabel
                            control={
                              <>
                                <Checkbox checked />
                                <s>Use REST-APIs to upload/update End-User accounts</s>
                              </>
                            }
                            label=' '
                          />
                        </>
                      ) : (
                        <>
                          <FormControlLabel
                            control={<Checkbox onChange={handleChange} />}
                            value='uploadUpdateEndUserAccount'
                            label='Use REST-APIs to upload/update End-User accounts'
                          />
                        </>
                      )}
                      {tierTypeData?.configurePortalWithLdapAuthentication ? (
                        <>
                          <FormControlLabel
                            control={
                              <>
                                <Checkbox checked />
                                <s>Setup your Apps/Portals with EasyIdentity Cloud Directory for user authentication</s>
                              </>
                            }
                            label=' '
                          />
                        </>
                      ) : (
                        <>
                          <FormControlLabel
                            control={<Checkbox onChange={handleChange} />}
                            value='configurePortalWithLdapAuthentication'
                            label='Setup your Apps/Portals with EasyIdentity Cloud Directory for user authentication'
                          />
                        </>
                      )}
                    </>
                  </FormControl>
                </>
              </div>
            </Grid>
          </form>
        </div>
      </Paper>
    </Modal>
  );
});

export default ClientProgress;
